import styled from '@tanium/react-emotion-9';
import { css } from '@tanium/style-system';

const BannerInModalWrapperDiv = styled('div')(
  css({
    width: 'calc(100% + 32px)',
    position: 'relative',
    top: '-25px',
    left: '-16px',
  })
);

export default BannerInModalWrapperDiv;
